import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { RouterProvider } from 'react-router';
import { createQueryClient } from '#src/app/query-client';
import { createRouter } from '#src/app/router';
import { AuthProvider } from '#src/auth/AuthProvider';
import { SessionGate } from '#src/auth/session';
import { TeamsHostProvider } from '#src/teams/TeamsHostProvider';
import { ThemeProvider } from '#src/theme/ThemeProvider';

/**
 * Ordem dos providers, de fora para dentro: descobrir se está no Teams, aplicar
 * o tema (que depende disso), obter o token (idem), carregar a sessão e só
 * então as rotas, que já sabem as permissões.
 */
export function App() {
  const [queryClient] = useState(createQueryClient);
  const [router] = useState(createRouter);

  return (
    <TeamsHostProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <SessionGate>
              <RouterProvider router={router} />
            </SessionGate>
          </AuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </TeamsHostProvider>
  );
}
